var _path, _path2, _path3, _path4, _polygon, _path5, _polygon2, _path6, _path7, _path8, _path9, _circle, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e100174e-19fc-42f4-bc4a-8842c5fdaddf",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 557.99124,
    height: 512.53,
    viewBox: "0 0 657.99124 512.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M530.696,329.75826a13.11407,13.11407,0,0,0-.75717,1.92131l-59.16128,17.831-10.954-10.26356-17.65025,14.507,17.62618,20.05417a9.96748,9.96748,0,0,0,11.709,2.44875l63.679-29.77828a13.0787,13.0787,0,1,0-4.49138-16.72041Z",
    transform: "translate(-271.00438 -193.735)",
    fill: "#ffb6b6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M468.81379,350.2319,447.048,368.34557a5.60675,5.60675,0,0,1-8.37488-1.39312L423.98932,342.8404A15.571,15.571,0,0,1,447.98465,322.99L468.965,341.74329a5.60675,5.60675,0,0,1-.15122,8.48861Z",
    transform: "translate(-271.00438 -193.735)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M527.26275,651.82131l9.47381-6.03528a141.38928,141.38928,0,0,0,.40722-15.93137l-4.91442,1.25556,4.85063-3.09c-.26791-6.56876-.86121-10.90172-.86121-10.90172s-19.15482,12.44206-31.37126,29.30667l2.08318,14.26309-4.9681-9.97458a57.199,57.199,0,0,0-3.41785,6.324c-10.06525,21.98884-11.04334,43.10159-2.18448,47.15668s24.19979-10.48311,34.26506-32.47195A75.30884,75.30884,0,0,0,536.3605,649.497Z",
    transform: "translate(-271.00438 -193.735)",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M546.723,673.04564l11.22966-.26943a141.38719,141.38719,0,0,0,8.58354-13.42749l-4.85594-1.46544,5.74958-.13792c3.16606-5.76163,4.89791-9.77755,4.89791-9.77755s-22.82871.74979-42.00387,8.872l-5.58932,13.28666.903-11.10673a57.20134,57.20134,0,0,0-6.19473,3.647c-19.9824,13.62068-31.73284,31.18859-26.24538,39.23906s26.13486,3.53489,46.11722-10.08578a75.309,75.309,0,0,0,16.398-16.06145Z",
    transform: "translate(-271.00438 -193.735)",
    fill: "#e6e6e6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "209.349 499.141 221.609 499.14 226.208 451.454 209.347 451.853 209.349 499.141",
    fill: "#ffb6b6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M477.22638,688.87313l24.144-.001h.001a15.3873,15.3873,0,0,1,15.38647,15.38623v.5l-39.53076.00146Z",
    transform: "translate(-271.00438 -193.735)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "64.712 463.751 72.753 473.005 112.275 446.394 100.407 432.735 64.712 463.751",
    fill: "#ffb6b6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M336.687,652.49968,352.52283,670.725l.00064.00073A15.38729,15.38729,0,0,1,351,692.43192l-.37744.32793-25.92767-29.84019Z",
    transform: "translate(-271.00438 -193.735)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M272.19507,706.265h334.294a1.19068,1.19068,0,1,0,0-2.38137h-334.294a1.19069,1.19069,0,1,0,0,2.38137Z",
    transform: "translate(-271.00438 -193.735)",
    fill: "#cacaca"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M453.41806,580.627l25.79454,95.56236h20l-4.3928-104.514L483.225,469.84933l-42.1156-2.23791Z",
    transform: "translate(-271.00438 -193.735)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M408.65939,469.84927s-2.23791,14.54657,6.71381,30.2121,3.35687,68.257,3.35687,68.257L343.2126,644.18934s11.73635,20.36019,17.33119,19.24123S454.537,590.69772,454.537,590.69772l28.688-116.37256Z",
    transform: "translate(-271.00438 -193.735)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 179.29466,
    cy: 80.98649,
    r: 25.73625,
    fill: "#ffb6b6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M449.2126,315.18934s-30-11.3569-30-8-29.5756,31.74083-22.8618,68.66674,14.54657,54.82937,11.18964,74.97079-1.119,24.61725-1.119,24.61725,77.92248,6.71381,79.04144-1.119-3.25026-19.77888-3.25026-23.13576S451.29333,323.82785,449.2126,315.18934Z",
    transform: "translate(-271.00438 -193.735)",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M438.65054,290.18628c2.0835-1.10163,4.50373-1.32871,6.75892-2.01343,8.06829-2.44974,13.4732-11.5705,11.74762-19.824a10.11478,10.11478,0,0,1-.42377-3.26724c.30163-2.44446,2.80292-4.0217,5.20135-4.58179s4.95038-.47873,7.2428-1.37936c3.53955-1.39059,5.89069-5.02808,6.40039-8.79669a18.171,18.171,0,0,0-2.42731-10.952l-.86633,2.493a9.24692,9.24692,0,0,1-2.83075-4.23376,5.83213,5.83213,0,0,0-4.44348,3.5733c-1.39062.82-1.591-2.54754-3.127-3.04434a2.75911,2.75911,0,0,0-1.91724.4729c-3.09521,1.4436-6.69134.20932-10.0116-.59088a37.68771,37.68771,0,0,0-17.4953-.0206c-3.82183.91159-7.60479,2.499-10.3396,5.32a24.80848,24.80848,0,0,0-4.83679,8.31134c-2.93323,7.38193-4.87091,15.36941-3.90265,23.25351a32.91457,32.91457,0,0,0,7.75684,17.43942c2.21466,2.55167,9.44031,11.45374,13.40222,9.936C439.51706,300.37463,432.78494,293.28759,438.65054,290.18628Z",
    transform: "translate(-271.00438 -193.735)",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 427.01599,
    y: 551.51707,
    width: 82.62854,
    height: 1.59216,
    transform: "translate(-485.62156 599.33913) rotate(-69.12314)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M545.87377,318.19025a7.07362,7.07362,0,0,0-7.06529,7.06529v78.54193a7.07362,7.07362,0,0,0,7.06529,7.06528H921.93033a7.07361,7.07361,0,0,0,7.06529-7.06528V325.25555a7.0736,7.0736,0,0,0-7.06529-7.06528Z",
    transform: "translate(-271.00438 -193.735)",
    fill: "#e6e6e6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M548.41423,323.69965a4.10124,4.10124,0,0,0-4.09712,4.09635v73.461a4.10135,4.10135,0,0,0,4.097,4.09635H919.38987a4.10012,4.10012,0,0,0,4.09566-4.09635V327.796a4.10012,4.10012,0,0,0-4.09566-4.09635Z",
    transform: "translate(-271.00438 -193.735)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M896.09755,385.20922a6.656,6.656,0,0,0,.018-13.31189c-.006,0-.012,0-.018,0H582.31767a6.656,6.656,0,0,0,0,13.31189Z",
    transform: "translate(-271.00438 -193.735)",
    fill: "#e6e6e6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M717.338,356.29267a6.65594,6.65594,0,1,0,0-13.31187H582.31767a6.65594,6.65594,0,1,0,0,13.31187Z",
    transform: "translate(-271.00438 -193.735)",
    fill: "#f9224b"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M600.83711,469.735a5.00588,5.00588,0,0,0-5,5v55.583a5.00589,5.00589,0,0,0,5,5H866.967a5.00589,5.00589,0,0,0,5-5V474.735a5.00588,5.00588,0,0,0-5-5Z",
    transform: "translate(-271.00438 -193.735)",
    fill: "#e6e6e6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M602.635,473.63392a2.90239,2.90239,0,0,0-2.89947,2.89893v51.98731a2.90245,2.90245,0,0,0,2.89941,2.89892H865.16914a2.9016,2.9016,0,0,0,2.89844-2.89892V476.53285a2.9016,2.9016,0,0,0-2.89844-2.89893Z",
    transform: "translate(-271.00438 -193.735)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M848.6855,517.16337a4.71032,4.71032,0,0,0,.01275-9.42063c-.00427,0-.00848,0-.01275,0H626.62794a4.71032,4.71032,0,0,0,0,9.42063Z",
    transform: "translate(-271.00438 -193.735)",
    fill: "#e6e6e6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M722.17994,496.69954a4.71032,4.71032,0,1,0,0-9.42063h-95.552a4.71032,4.71032,0,1,0,0,9.42063Z",
    transform: "translate(-271.00438 -193.735)",
    fill: "#e4e4e4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M600.83711,193.735a5.00588,5.00588,0,0,0-5,5v55.583a5.00589,5.00589,0,0,0,5,5H866.967a5.00589,5.00589,0,0,0,5-5V198.735a5.00588,5.00588,0,0,0-5-5Z",
    transform: "translate(-271.00438 -193.735)",
    fill: "#e6e6e6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M602.635,197.63392a2.90239,2.90239,0,0,0-2.89947,2.89893v51.98731a2.90245,2.90245,0,0,0,2.89941,2.89892H865.16914a2.9016,2.9016,0,0,0,2.89844-2.89892V200.53285a2.9016,2.9016,0,0,0-2.89844-2.89893Z",
    transform: "translate(-271.00438 -193.735)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M848.6855,241.16337a4.71032,4.71032,0,0,0,.01275-9.42063c-.00427,0-.00848,0-.01275,0H626.62794a4.71032,4.71032,0,0,0,0,9.42063Z",
    transform: "translate(-271.00438 -193.735)",
    fill: "#e6e6e6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M722.17994,220.69954a4.71032,4.71032,0,1,0,0-9.42063h-95.552a4.71032,4.71032,0,1,0,0,9.42063Z",
    transform: "translate(-271.00438 -193.735)",
    fill: "#e4e4e4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M522.46133,374.84878a13.11484,13.11484,0,0,0-1.37393,1.54178l-61.67969-3.69006-6.73715-13.41426-21.5734,7.52156,9.619,24.90637a9.9675,9.9675,0,0,0,10.14364,6.34057l70.04426-5.963a13.07871,13.07871,0,1,0,1.55729-17.243Z",
    transform: "translate(-271.00438 -193.735)",
    fill: "#ffb6b6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M457.31564,372.69953l-26.681,9.48559a5.60674,5.60674,0,0,1-7.379-4.19879L417.799,350.28741a15.571,15.571,0,0,1,29.37308-10.3458l13.21606,24.84344a5.60674,5.60674,0,0,1-3.07252,7.91448Z",
    transform: "translate(-271.00438 -193.735)",
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 277.99124,
    cy: 132.61828,
    r: 17,
    fill: "#f9224b"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.029634e28b0cbbb05b198f2f7095711a.svg";
export { ForwardRef as ReactComponent };